import { getAmplitudeInstance } from '../amplitudeHelpers';
import CardLocation from '../enums/CardLocation';

type logTripPlannerCTAClickedParams = {
  entry_point?: CardLocation;
  location_id?: number;
  park_id?: number;
};

/**
 * User taps the Trip Planner entry CTA on web (explore, park page, or location page).
 * @param params - Attributes to log with the amplitude event
 * @param params.entry_point - Surface where the Trip Planner CTA was tapped.
 * @param params.location_id - Id of the location associated with the page where the CTA was tapped, if applicable.
 * @param params.park_id - Id of the park associated with the page where the CTA was tapped, if applicable.
 */
const logTripPlannerCTAClicked = ({ entry_point, location_id, park_id }: logTripPlannerCTAClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'trip planner cta clicked',
    { 'entry point': entry_point, 'location id': location_id, 'park id': park_id },
    callback
  );
};

export default logTripPlannerCTAClicked;
